import { GameStatus } from 'twain-sport-fe-mono';
import { TwainGameId } from 'betgames-contract-js';
import { IGame } from 'interfaces/IGame';

export const getPresetsIds = (data: IGame[]): Record<TwainGameId, number> =>
    data.reduce((list, game) => {
        if (game.status === GameStatus.AVAILABLE) {
            list[game.id] = game.bettingOptionPresetId;
        }
        return list;
    }, {} as Record<TwainGameId, number>);
